// React
import React, { useContext, useState, useEffect } from "react";
// React
// CSS
import styles from "./PdfMaker.module.css";
// CSS
// Models
import { I_QuizMakerQuestions } from "../../../Models/interfaces";
import { requestPdfFileService } from "../../../Services/Profile/post/requestPdfFileService";
import { LessonDataContext } from "../../../Contexts/LessonDataContext";
import { UserTokenContext } from "../../../Contexts/userToken";
import Swal from "sweetalert2";
import Spinner from "../../../Utils/Spinner/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
import { sendPdfRequestForFullQuizService } from "../../../Services/Common/sendPdfRequestForFullQuizService";
import { toast } from "react-toastify";
import QuestionModalForShowQuestion from "../../QuestionCreatorQuestionViewer/QuestionCard/QuestionModalForShowQuestion/QuestionModalForShowQuestion";
import { BiArrowBack } from "react-icons/bi";
// import { UserTokenContext } from "../../../Contexts/userToken";
// Models

type PdfMakerProps = {
  questions: I_QuizMakerQuestions[];
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const PdfMaker: React.FunctionComponent<PdfMakerProps> = ({
  questions,
  setIsNeedFullScreen,
}) => {
  // States
  const [selectedQuestions, setSelectedQuestions] = useState<string[]>([]);
  //
  const [isPending, setIsPending] = useState<boolean>(false);
  // States

  const [imageUrl, setImageUrl] = useState<string>("");

  const [isImageZoomInScreen, setIsImageZoomInScreen] =
    useState<boolean>(false);

  const { state } = useLocation();
  useEffect(() => {
    Swal.fire({
      icon: "info",
      title: "ساخت pdf",
      text: "برای ساخت فایل pdf بعد از کلیک بر روی شروع انتخاب ، سوالاتی که مایلید در فایل pdf قرار گیرند را لمس کنید تا رنگ زمینه ی آنها به سبز تغییر پیدا کند ، سپس بر روی اتمام کار ساخت کلیک کنید تا ساخت شروع شود . حداکثر 20 مورد انتخاب شود",
    });
  }, []);
  //
  useEffect(() => {
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  }, [setIsNeedFullScreen]);
  // Methods
  const createMarkup = (markup: string) => {
    return {
      __html: markup,
    };
  };
  //
  const adderToRequest = (qId: string) => {
    if (selectedQuestions.length >= 20) {
      Swal.fire({
        icon: "warning",
        title: "حداکثر 20 مورد قابل انتخاب است",
        showCancelButton: true,
        cancelButtonText: "لغو",
        showConfirmButton: true,
        confirmButtonText: "حذف سوال اول",
      })
        .then(({ isConfirmed }) => {
          if (isConfirmed) {
            const copyOfState = [...selectedQuestions];
            copyOfState.shift();
            copyOfState.push(qId);
            setSelectedQuestions(copyOfState);
            return;
          } else {
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      return;
    }
    if (selectedQuestions.includes(qId)) {
      const copyOfState = [...selectedQuestions];
      const index = selectedQuestions.findIndex((item) => item === qId);
      copyOfState.splice(index, 1);
      setSelectedQuestions(copyOfState);
      return;
    }
    setSelectedQuestions((prevState) => [...prevState, qId]);
  };
  // Methods
  // Contexts
  const userToken = useContext(UserTokenContext);
  const lessonData = useContext(LessonDataContext);
  // Contexts

  const navigate = useNavigate();

  return (
    <div
      className={`${styles.pdfMakerContainer} w-full p-4 flex flex-col items-end pb-24 dark:!text-black`}
    >
      {/*  */}
      {isImageZoomInScreen ? (
        <QuestionModalForShowQuestion
          questionImageUrl={imageUrl}
          setIsModalInScreen={setIsImageZoomInScreen}
        />
      ) : null}
      {/*  */}
      <div
        onClick={() => {
          navigate(-1);
        }}
        className="flex items-center justify-center py-2"
      >
        <span>برای بازگشت ضربه بزنید</span>

        <BiArrowBack className="absolute left-3 text-2xl" onClick={() => {}} />
      </div>
      {questions.map((item, index) => (
        <div
          key={item.id}
          className={`w-full  ${
            selectedQuestions.includes(String(item.id)) ? "!bg-green-200 " : ""
          } p-4 mt-4 rounded-xl bg-white flex flex-col items-end`}
          onClick={() => {
            adderToRequest(String(item.id));
          }}
        >
          <div className="w-full flex items-center justify-between py-2">
            <span
              style={{ background: "rgb(126 , 58 , 209)" }}
              className="rounded-full  w-5 h-5 flex items-center justify-center text-white"
            >
              {index + 1}
            </span>
            <span>
              {((): string => {
                if (state?.currMode === "full") {
                  return String(item.lesson_name);
                } else {
                  console.log(state.lessonName);
                  return String(lessonData?.lessonName ?? state.lessonName);
                }
              })()}
            </span>
          </div>
          <div style={{ borderBottom: `1px solid #858585` }}>
            {item.title ? (
              <div
                dangerouslySetInnerHTML={createMarkup(String(item.title))}
                className="text-right"
                style={{
                  direction: "rtl",
                }}
              ></div>
            ) : null}
            {item.image_url ? (
              <div
                onClick={() => {
                  setImageUrl(item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":"));
                }}
                className="w-full py-2"
              >
                <img
                  src={item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                  alt=""
                  className="w-full h-20 object-contain"
                />
              </div>
            ) : null}
          </div>
          {item.options.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-end justify-center"
            >
              {item.image_url ? (
                <img
                  src={item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                  alt=""
                  className="w-full h-10 mt-2 object-contain"
                />
              ) : null}
              {item.title ? (
                <span
                  dangerouslySetInnerHTML={createMarkup(item.title)}
                  className=" mt-2"
                  style={{
                    direction: "rtl",
                  }}
                ></span>
              ) : null}
            </div>
          ))}
          {item.answer_file_url !== "null" ? (
            <>
              <p>پاسخ</p>
              {Boolean(item.answer_file_url) ? (
                <div
                  onClick={() => {
                    setImageUrl(item.answer_file_url);
                  }}
                >
                  <img
                    src={item.answer_file_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                    alt=""
                  />
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      ))}
      <button
        className={`${styles.submitBtn} mt-10 w-full py-2  "!left-0"
         text-white flex justify-center items-center fixed  bottom-0`}
        style={{
          background: isPending ? "rgb(244, 67, 54)" : "#fff",
          borderRadius: isPending ? "8px" : "",
          marginRight: window.innerWidth > 600 ? "-36px" : "",
        }}
        onClick={() => {
          if (!lessonData) return;
          if (isPending) return;
          if (selectedQuestions.length === 0) {
            toast("حداقل یک سوال را انتخاب کنید");
            return;
          }
          setIsPending(true);
          if (
            String(state.currMode) === "full" &&
            Number.isInteger(Number(state.quizId))
          ) {
            sendPdfRequestForFullQuizService(
              userToken,
              String(state.quizId),
              selectedQuestions
            )
              .then(({ data: { success } }) => {
                setIsPending(false);
                Swal.fire({
                  icon: "success",
                  title: success,
                  confirmButtonText: "رفتن به درخواست ها",
                }).then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    navigate("/profile/files");
                  }
                });
              })
              .catch((err) => {
                console.log(err);
                setIsPending(false);
              });
            return;
          } else {
            requestPdfFileService(
              userToken,
              selectedQuestions,
              lessonData.lessonId,
              lessonData.subjectId
            )
              .then(({ data: { success } }) => {
                setIsPending(false);
                Swal.fire({
                  icon: "success",
                  title: success,
                  confirmButtonText: "رفتن به درخواست ها",
                }).then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    navigate("/profile/files");
                  }
                });
              })
              .catch((err) => {
                console.log(err);
                setIsPending(false);
                Swal.fire({
                  icon: "error",
                  title: err?.response?.data?.message
                    ? err?.response?.data?.message
                    : err.message,
                });
              });
            return;
          }
        }}
      >
        {isPending ? (
          <>
            <Spinner />
          </>
        ) : (
          <>
            {selectedQuestions.length === 0 ? (
              <span
                className={`${styles.pdfMakerInner} ${
                  window.innerWidth > 600 ? "!w-full !left-0 " : ""
                } flex items-center justify-center`}
                style={{
                  background:
                    selectedQuestions.length === 0
                      ? "rgba(244, 67, 54 , 0.9)"
                      : "rgb(244, 67, 54)",
                }}
              >
                لطفا یک مورد را انتخاب کنید
              </span>
            ) : (
              <span className={`${styles.pdfMakerInner} w-full`}>
                PDF ثبت درخواست ساخت
              </span>
            )}
          </>
        )}
      </button>
    </div>
  );
};

export default PdfMaker;
